import { formatDayLabel } from '@/utils/format-date';
import { dayKey } from '@/pages/schedules/helpers/day-range';
import type { ScheduledRun } from '@/types/schedules';

export interface RunDayGroup {
  key: string;
  label: string;
  runs: ScheduledRun[];
}

/**
 * Group runs into day buckets, preserving the input order (expected
 * newest-first). Runs without a usable timestamp are bucketed under "Unknown".
 */
export function groupRunsByDay(runs: ScheduledRun[]): RunDayGroup[] {
  const groups: RunDayGroup[] = [];
  const index = new Map<string, RunDayGroup>();

  for (const run of runs) {
    const raw = run.started_at ?? run.created_at;
    const date = raw ? new Date(raw) : null;
    const key = date && !isNaN(date.getTime()) ? dayKey(date) : 'unknown';
    let group = index.get(key);
    if (!group) {
      group = {
        key,
        label: raw ? formatDayLabel(raw) : 'Unknown date',
        runs: [],
      };
      index.set(key, group);
      groups.push(group);
    }
    group.runs.push(run);
  }

  return groups;
}
